var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('api-form',{ref:"apiForm",attrs:{"no-reset":"","reset-btn":"","initial":_vm.initial,"fields":_vm.fields,"method":_vm.saveAttrs,"btn-props":{
    btnText: 'Сохранить и продолжить',
    rounded: true,
    color: 'success'
  }},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }